<template>
  <div class="bitts-table__column-header flex items-center gap-6">
    <BittsSvg :svg="icon" class="h-12 w-12" />
    <span class="text-neutral-text-strong">{{ displayName }}</span>
  </div>
</template>

<script setup lang="ts">
import { BittsSvg } from '@crossbeam/bitts';

import { IHeaderParams } from '@ag-grid-community/core';

const props = defineProps<{
  params: IHeaderParams & {
    icon: string;
    displayName: string;
  };
}>();

const { icon, displayName } = props.params;
</script>
